"use client";

import React from "react";

interface WheelStatusMessageProps {
  isSpinning: boolean;
  clientSideDelay: number;
}

/**
 * Displays the current status of the wheel (spinning, waiting, or ready)
 */
export const WheelStatusMessage: React.FC<WheelStatusMessageProps> = ({ isSpinning, clientSideDelay }) => {
  const getStatusMessage = () => {
    if (isSpinning) return "Spinning...";
    if (clientSideDelay > 0) return `Wait ${clientSideDelay}s`;
    return "";
  };

  const message = getStatusMessage();

  return (
    <div className="w-full text-center min-h-[32px]">
      {message ? (
        <p className="text-lg font-semibold text-cede-primary">{message}</p>
      ) : (
        <p className="text-sm text-cede-text-secondary">Spin the wheel to get your reward</p>
      )}
    </div>
  );
};
